import { isKnytNode } from "./KnytNode.js";
export function isKnytContent(value) {
    return (isKnytNode(value) ||
        typeof value === "number" ||
        typeof value === "string" ||
        value == null ||
        value === false);
}
